import { ref, useContext } from "@nuxtjs/composition-api";
const DOCUMENT_TYPES = {
  CERTIFICATES: "Certificates",
  POLICIES: "Privacy Policy",
  DRIVERS: "Drivers",
  SOFTWARE: "Software",
  VIDEOS: "Video guide"
};
function splitFiltersByGroups(filters) {
  const groups = {};
  const addToGroup = (param, type = "all") => {
    if (!groups[type]) {
      groups[type] = { ...param };
    } else {
      const { include, exclude } = param;
      if (include)
        groups[type].include = [...groups[type].include ?? [], ...include];
      if (exclude)
        groups[type].exclude = [...groups[type].exclude ?? [], ...exclude];
    }
  };
  if (Array.isArray(filters)) {
    addToGroup({ include: filters });
  } else if (typeof filters === "object") {
    if (filters.include || filters.exclude) {
      addToGroup({ ...filters });
    } else {
      Object.entries(filters).forEach(
        ([type, filter]) => {
          if (Array.isArray(filter))
            addToGroup({ include: filter }, type);
          else addToGroup({ ...filter }, type);
        }
      );
    }
  }
  return groups;
}
function filterDocuments(documents, grouping) {
  const groups = splitFiltersByGroups(grouping);
  const result = Object.keys(groups).reduce(
    (keys, key) => ({ ...keys, [key]: [] }),
    {}
  );
  Object.entries(documents).forEach((entry) => {
    const [group, docs] = entry;
    Object.keys(groups).forEach((groupKey) => {
      const groupFilter = groups[groupKey];
      const { include, exclude } = groupFilter;
      if (include && !include.includes(group) || exclude && exclude.includes(group)) {
        return;
      }
      result[groupKey].push(...docs);
    });
  });
  return result;
}
function filterDocumentsBySku(documents, grouping) {
  return Object.entries(documents).reduce((items, item) => {
    const [sku, documentsSection] = item;
    const grouped = filterDocuments(documentsSection, grouping);
    return { ...items, [sku]: grouped.all };
  }, {});
}
function useFetchDocuments() {
  const { $api } = useContext();
  const documents = ref();
  const documentsMeta = ref();
  const fetchDocuments = async (query, grouping) => {
    try {
      const { data, meta } = await $api.documentsService.getAllDocuments(query);
      documents.value = filterDocuments(data, grouping);
      documentsMeta.value = meta;
    } catch (e) {
      console.error("Fetch documents failed: ", e);
    }
  };
  const fetchDocumentsGroupedByProducts = async (params, grouping = {}) => {
    try {
      const result = await $api.documentsService.getDocumentsGroupedByProducts(
        params
      );
      documents.value = filterDocumentsBySku(result.data, grouping);
    } catch (e) {
      console.error("Fetch documents failed: ", e);
    }
    return {};
  };
  const fetchDocumentsGroupedBySkus = async (params, grouping = {}) => {
    try {
      const { data } = await $api.documentsService.getDocumentsGroupedBySku(
        params
      );
      documents.value = filterDocumentsBySku(data, grouping);
    } catch (e) {
      console.error("Fetch documents failed: ", e);
    }
    return {};
  };
  return {
    documents,
    documentsMeta,
    fetchDocuments,
    fetchDocumentsGroupedByProducts,
    fetchDocumentsGroupedBySkus,
    DOCUMENT_TYPES
  };
}
var useFetchDocuments_default = useFetchDocuments;
export {
  useFetchDocuments_default as default
};
